import {InputAdornment} from '@mui/material';
import MuiBox from '../MuiBox';
import MuiTextField from '../MuiTextField';
import MuiDivider from '../MuiDivider';

type Props = {
  minValue: number | null;
  maxValue: number | null;
  minPlaceholder: string;
  maxPlaceholder: string;
  step?: number;
  suffix?: string;
  handleMinInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleMaxInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleMinBlur: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => void;
  handleMaxBlur: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => void;
};

const RangeInputs = (props: Props) => {
  return (
    <MuiBox display='flex' justifyContent='space-between' alignItems='center'>
      <MuiTextField
        placeholder={props.minPlaceholder}
        type='number'
        value={props.minValue ?? ''}
        onChange={props.handleMinInputChange}
        onBlur={props.handleMinBlur}
        inputProps={{
          step: props.step,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>{props.suffix}</InputAdornment>
          ),
          sx: {
            borderRadius: '10px',
            height: '40px',
            border: '1px solid #BABAC8',
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#BABAC8',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#BABAC8',
              boxShadow: 'none',
            },
          },
        }}
      />
      <MuiDivider
        orientation='horizontal'
        sx={{
          color: '#82807E',
          width: '20px',
          borderTopWidth: 2,
          margin: '0px 10px',
        }}
      />
      <MuiTextField
        placeholder={props.maxPlaceholder}
        type='number'
        value={props.maxValue ?? ''}
        onChange={props.handleMaxInputChange}
        onBlur={props.handleMaxBlur}
        inputProps={{
          step: props.step,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>{props.suffix}</InputAdornment>
          ),
          sx: {
            borderRadius: '10px',
            height: '40px',
            border: '1px solid #BABAC8',
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#BABAC8',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#BABAC8',
              boxShadow: 'none',
            },
          },
        }}
      />
    </MuiBox>
  );
};

export default RangeInputs;
